// extracted by mini-css-extract-plugin
export default {"animasjonsscroll":"dh-ans-animasjonsscroll--eJ4sF","vertical":"dh-ans-vertical--ag8pn","horizontal":"dh-ans-horizontal--HcKWL"};